"use client"

// src/components/circle-progress.ts
var CircleProgress = {
  baseStyle: {
    display: "inline-block",
    position: "relative",
    verticalAlign: "middle"
  }
};

export {
  CircleProgress
};
//# sourceMappingURL=chunk-W3T22VL7.mjs.map